import { render, staticRenderFns } from "./RenewalPercentageBreakdown.vue?vue&type=template&id=d435cd1a&"
import script from "./RenewalPercentageBreakdown.vue?vue&type=script&lang=js&"
export * from "./RenewalPercentageBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports